export const NEIGHBORHOOD_CONFIG = Object.freeze({
  namedSimulationRadiusM: 96,
  namedDespawnRadiusM: 112,
  ambientSpawnRadiusM: 72,
  ambientDespawnRadiusM: 88,
  ambientPopulationCap: 6,
  interactionRadiusM: 3.2,
  ambientWalkSpeedMps: 0.72,
  namedPedestrianSnapRadiusM: 12,
  // User-tuning candidate: how far a loaded named resident paces from its authored anchor.
  namedWalkingPatrolRadiusM: 8,
  authoredInteriorAmbientRadiusM: 88,
  populationRenderCapacity: 18,
});
